import { z } from 'zod';

// Messages are threaded per-request: every Request has its own message stream.
// Internal-only messages are visible to staff but never to the client; useful
// for engagement leads to leave notes for analysts without polluting the
// client-facing thread.

export const MessageInputSchema = z.object({
  request_id: z.string().min(1),
  body: z.string().min(1).max(10_000),
  // When true, the message is staff-only. Only staff can set this true; clients
  // are rejected at the API layer (defense-in-depth — the UI also hides it).
  internal: z.boolean().default(false),
});
export type MessageInput = z.infer<typeof MessageInputSchema>;

export const MessageDtoSchema = z.object({
  id: z.string(),
  request_id: z.string(),
  client_id: z.string(),

  author_id: z.string(),
  author_name: z.string(),
  author_kind: z.enum(['staff', 'client', 'system']),

  body: z.string(),
  internal: z.boolean(),

  // Per-user read receipts. Indexed for fast unread counts.
  read_by: z.array(z.string()),

  created_at: z.string(),
});
export type MessageDto = z.infer<typeof MessageDtoSchema>;
